export const SIGN_UP = '/signup'
export const SIGN_IN = '/login'
export const SIGN_OUT = '/signout'
export const LANDING = '/'
export const HOME = '/home'
export const ACCOUNT = '/account'
export const PASSWORD_FORGET = '/pw-forget'
export const WEBMD = '/webmd'
export const WEBMD_CONFIRMATION = '/webmd/confirmation'
